module.exports = __webpack_public_path__ + "img/LewisFace.578755d0.jpg";